import { useState } from "react";
import { Download } from "lucide-react";
import UserGrowthChart from "./components/UserGrowthChart";
import OrganizationGrowthChart from "./components/OrganizationGrowthChart";
import StatsCards from "./components/StatsCards";
import ActiveUsersChart from "./components/ActiveUsersChart";
import AccountDistributionChart from "./components/AccountDistributionChart";
import BulkDownloadModal from "../../modals/BulkDownloadModal";

function AdminDashboard() {
  const [isBulkDownloadOpen, setIsBulkDownloadOpen] = useState(false);

  return (
    <div className="bg-gray-100 h-full flex flex-col overflow-hidden">
      <div className="w-full mx-auto pt-6 sm:pt-12 px-4 sm:px-6 lg:px-10 flex-shrink-0">
        <div className="mb-4 sm:mb-6 flex items-start justify-between gap-4">
          <div>
            <h3 className="text-xl sm:text-2xl font-semibold">Dashboard</h3>
            <p className="m-0 text-sm sm:text-base text-gray-500">View platform statistics and growth</p>
          </div>
          <button
            onClick={() => setIsBulkDownloadOpen(true)}
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-[var(--dr-dark)] rounded-lg hover:opacity-90 transition-opacity flex-shrink-0"
          >
            <Download size={15} />
            Download Bulk Files
          </button>
        </div>
      </div>
      <BulkDownloadModal isOpen={isBulkDownloadOpen} setIsOpen={setIsBulkDownloadOpen} />
      <div className="flex-1 overflow-y-auto px-4 sm:px-6 lg:px-10 pt-4 sm:pt-6 pb-8 sm:pb-12">
        <div className="grid gap-6">
          <StatsCards />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <ActiveUsersChart />
            <UserGrowthChart />
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <AccountDistributionChart />
            <OrganizationGrowthChart />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
